import React from "react";
import { connect } from "react-redux";
import TextChart from "../../../Charts/TextChart";

const TextoChequesRechazados = (props) => {
  const {
    monto,
    cantidadCheques,
    loading,
    error,
  } = props;

  return (
    <TextChart
      title={`Cheques rechazados`}
      bigAmount={monto}
      smallAmount={cantidadCheques}
      smallAmountTooltip={`Cant. cheques`}
      bigCurrency
      loading={loading}
      imgSinDatos={error}
      onBodyClick={() => props.onBodyClick()}
      cursorPointer
    />
  );
};

const mapStateToProps = (state) => {
  return {
    monto: state.cheques.chequesRechazados.monto,
    cantidadCheques: state.cheques.chequesRechazados.cantidadCheques,
    loading: state.cheques.chequesRechazados.loading,
    error: state.cheques.chequesRechazados.error,
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(TextoChequesRechazados);
